<template>
    <div>
        <modal
        class="new-modal-default"
        transition="nice-modal-fade"
        :name="modal_name" 
        :delay="100" 
        height="auto"
        :width="200"
        :adaptive="true" :scrollable="true"
        >
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header justify-content-center" style="background-color: #f0ddb7 !important; ">
                    
                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/facility-management/featureImg.png" class="mr-2" style="width:25%; height: 100%;">
                   
                    
                </div>
                <div class="v-modal-body">
                    <div class="v-modal-layout">
                       
                            <div class="fs-16 fw-600 text-center my-4" style="color: #08448b;">
                                Feature coming soon!!
                            </div>
                            <div  class="d-flex align-items-center justify-content-center mt-10 mb-4">
                                <button type="button" class="btn btn-new-primary" @click="hideModal" >Close</button>
                            </div>
                        
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import facility_mgmt from '../mixins/facility_mgmt';
export default {
    mixins: [facility_mgmt],
    components: { 
        SweetModal
    },
    data() {
        return {
            success_msg: '',
            warning_msg: '',
            skip: 0,
            limit: 10,
            search_key: '',
            list_data: [],
            ajax_call_in_progress: false
        }
    },
    props: ["modal_name"],
    methods: {
       
        hideModal() {
            this.$emit('hideModal')
        },
    },
   
    computed: {
        loggedInUser() {
            return this.$store.getters.loggedInUser;
        },
    },
}
</script>
<style scoped>
    .search_input {
        padding: 8px 9.4px 6.5px 33.4px;
        border-radius: 24px;
        background-color: #fff;
        border: solid 0.5px #00448b;
    }
    .align-position {
        position: absolute;
        left: 10px;
        top: 7px;
        color: rgba(103, 103, 103, 0.84);
    }
</style>